@if (data.is_pcp_required || data.is_pcd_required) {
  <div
    class="CareTeam__Cards"
    [ngClass]="{ 'CareTeam__Cards--Columns': columns }"
  >
    @if (data.pcps.length > 0) {
      @for (pcp of data.pcps | filterCareCardDentists: config; track pcp) {
        <section class="CareTeamCard">
          @if (pcp) {
            <div class="CareTeamCard__Header">
              <h6
                class="t-bold"
                [innerHTML]="pcp | formatCareCardTitle: config"
              ></h6>
            </div>
          }
          <div class="u-flex">
            <div class="CareTeamCard__Icon">
              <icon
                [name]="config.icon || 'icon-hospital'"
                [config]="{
                  size: config.icon_size || copy.iconSize,
                  set: config.icon_set || copy.iconSet,
                  format: 'svg',
                }"
              >
              </icon>
            </div>
            <div>
              <p
                class="t-bold"
                [innerHTML]="pcp.pcp_name | formatCareCardName | nbspRemove"
              ></p>
              <p
                class="CareTeamCard__PhoneNumber"
                [innerHTML]="pcp.pcp_office_phone | formatCareCardPhoneNumber"
              ></p>
              <p class="t-caption" [innerHTML]="pcpAddress(pcp)"></p>
              <p class="CareTeamCard__Address">
                <span
                  class="CareTeamCard__AddressValues"
                  [innerHTML]="pcp.pcp_address?.city_name"
                ></span>
                <span
                  class="CareTeamCard__AddressValues"
                  [innerHTML]="pcp.pcp_address?.state"
                ></span>
                <span
                  class="CareTeamCard__AddressValues"
                  [innerHTML]="pcp.pcp_address?.zip_code"
                ></span>
              </p>
            </div>
          </div>
          <lib-care-card-footer
            [config]="config"
            [pcp]="pcp"
            [providerType]="
              pcp.type?.toLowerCase() === 'dentist' ? 'dentist' : 'pcp'
            "
            [instructionalText]="copy"
            (changePCPClicked)="linkClicked()"
          ></lib-care-card-footer>
        </section>
      }
    }
    <!-- EMPTY ADD PCP AND ADD PCD CARDS -->
    @if (!config.review_provider) {
      @if (data.is_pcp_required && listOfPCPs.length < 1) {
        <care-card-card
          [config]="config"
          providerType="pcp"
          (addPCPClicked)="addPCPClicked.emit()"
        ></care-card-card>
      }
      @if (
        data.is_pcd_required && config.show_dental && listOfPCDs.length < 1
      ) {
        <care-card-card
          [config]="config"
          providerType="dentist"
          (addPCPClicked)="addPCPClicked.emit()"
        ></care-card-card>
      }
    }
  </div>
}
